import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { TimeZoneOption } from '../models/time-zone-option';
import { timeZoneOptionSelectors } from '../state/time-zone-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: TimeZoneSelectComponent,
        },
    ],
    selector: 'ndt-time-zone-select',
    templateUrl: './time-zone-select.component.html',
    standalone: false
})
export class TimeZoneSelectComponent extends LcsSingleSelectBase<TimeZoneOption> implements OnInit {
   timeZones: Observable<TimeZoneOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.timeZones = this.store.pipe(select(timeZoneOptionSelectors.selectFilteredItems), this.itemsLoaded());
   }

   displayWith(item: TimeZoneOption | null): string | null {
      return item ? item.timeZoneId : null;
   }

   trackBy(item: TimeZoneOption | null) {
      return item ? item.timeZoneId : null;
   }
}
